export const environment = {
  ignoreValidators: false,
  production: false,
  disableCopy: false,
  apiMode: 'gateway', // apiMode: 'gateway' | 'soa' | 'siebel'
   api_gateway: 'https://apidev.dubaichamber.com/v1/',
   //'https://m4pmzdjigtktpkl6bul7xschcy.apigateway.me-dubai-1.oci.customer-oci.com/v1/',
  // api_gateway: 'https://10.60.66.43/v1/',
  api_siebel:
    'https://dcdevcrm.dubaichamber.com:9443/siebel/v1.0/service/Workflow%20Process%20Manager%20REST/',
  api_soa_dev: 'https://dcsoafmwdev.dubaichamber.com/',
  overrideReturnUrl: 'https://dcdevsso.dubaichamber.com:9443/commonauth',
  ssoSupportEmail: 'customercare@dubaichamber.com',
  api_soa_sit: 'https://dcsoafmwsit.dubaichamber.com/',
  venueImageHostUrl: 'https://stgvenues.dubaichamber.com',
  wso2URL: 'https://dcdevsso.dubaichamber.com',
  uaePassRedirectUri: 'https://dccommunitydev.dubaichamber.com/uaepass-login',
  multiFactorAuthEnabled: false,
  wso2AuthnUrl: 'https://apidev.dubaichamber.com/authentication/oauth2/authn',
  wso2APIURL: 'https://apidev.dubaichamber.com/authentication/',
  clientId: 'fIf9xEhrb8AvC01fdjuEITwDTqEa',
  token_exchange_clientId: 'xZESfb9onb5jzkb_YKWQvOrRDosa',
  scopes: 'openid profile email internal_login',
  responseType: 'code',
  servicesHappinessURL: 'https://stghappinessmeter.dubaichamber.com',
  businessGroupPlatformUrl: 'https://dcdigitalcrm.dubaichamber.com/siebel/app/pseservicesso/enu',
  documentEncryption: true,
  guestTokenUrl: 'https://apidev.dubaichamber.com/authentication/v1/oauth2/token',
  guestTokenScope: 'openid address email profile',
  guestUser:"GUESTCST",
  enableHappinessMeter: true,
  clientGatewayKey :'ViZSH-kyRBXCIPdT-GG1GoWarrYD2rC5kCqMEF2wA0s',
  mVP1Settings: {
    faqDropDownEnabled: true,
    chatEnabled: true,
    bgcEnabled: true,
    sustainabilityEnabled: false,
    accountManagementEnabled: true,
    ataEnabled: true,
    mediationEnabled: true,
    documentsEnabled: true,
    venueEnabled: true,
    directoryEnabled: true,
    searchEnabled: false,
    notificationsSettingsEnabled: true,
    showFavouriteButton: true,
    enableDashboardAlert: false,
  },
};
